import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import api from '../services/api';
import { useModal } from '../components/AppModal';

const ResetPassword = () => {
  const modal = useModal();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return modal.error('Falta el token en el enlace');
    if (password.length < 8) return modal.error('La contraseña debe tener al menos 8 caracteres');
    if (password !== confirm) return modal.error('Las contraseñas no coinciden');

    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      modal.success('Contraseña actualizada. Ya puedes iniciar sesión.');
      navigate('/login');
    } catch (err) {
      modal.error(err.response?.data?.message || 'Error fijando la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>CRM<span style={{ color: 'var(--accent)' }}>llor</span></h1>
        <p className="subtitle">Fijar nueva contraseña</p>
        {!token ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#b91c1c', marginBottom: 16 }}>
              Enlace inválido. Vuelve a solicitar la recuperación.
            </p>
            <Link to="/forgot-password" className="btn btn-outline" style={{ width: '100%', justifyContent: 'center' }}>
              Solicitar de nuevo
            </Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="form-group">
              <label className="form-label">Nueva contraseña</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-input"
                  style={{ paddingRight: 40 }}
                  placeholder="Mínimo 8 caracteres"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoFocus
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                  style={{
                    position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                    background: 'transparent', border: 'none', cursor: 'pointer',
                    color: '#64748b', display: 'flex', alignItems: 'center', padding: 4,
                  }}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Repite la contraseña</label>
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-input"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? 'Guardando...' : 'Fijar contraseña'}
            </button>
            <div style={{ marginTop: 16, textAlign: 'center', fontSize: 13 }}>
              <Link to="/login" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                Volver al login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
